import { useState } from "react"
import { CustomModal } from "@components"

import {
  Button, 
  Input,
  ModalContent, 
  ModalHeader, 
  ModalBody, 
  ModalFooter,
} from "@heroui/react";

import PropTypes from 'prop-types';

const EditGroupTitleModal = ({ 
  group,
  handleClose, 
  handleSave, 
  header = "Edit Group Title",
  isSaving, 
  show 
}) => {
  const [title, setTitle] = useState(group.title);

  const isValid = () => {
    return title.length >= 3 && title.length <= 30
  }
  
  return (
    <CustomModal
      isOpen={show}
      size="xl"
      handleClose={() => handleClose()}
      scrollBehavior="outside"
    >
      <ModalContent>
        {(onClose) => (
          <>
            <ModalHeader>{header}</ModalHeader>
          
            <ModalBody>
              <div className="mt-4">
                <p className="mb-2 text-content2-foreground">Edit Group Title</p>

                <Input
                  autoFocus
                  isRequired
                  type="text"
                  placeholder="Enter a group title"
                  value={title}
                  onValueChange={(value) => setTitle(value)}
                  minLength={3}
                  maxLength={30}
                  errorMessage="You must supply a title between 3 and 30 characters."
                />
              </div>
            </ModalBody>

            <ModalFooter>
              <div className="flex justify-between w-full">
                <Button onPress={() => handleClose()} tabIndex={-1}>Cancel</Button>
                <Button color="secondary" onPress={() => handleSave(group, title)} tabIndex={-1} isLoading={isSaving} isDisabled={!isValid()}>Save</Button>
              </div>
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </CustomModal>
  )
}

EditGroupTitleModal.propTypes = {
  group: PropTypes.object.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleSave: PropTypes.func.isRequired,
  header: PropTypes.string,
  isSaving: PropTypes.bool,
  show: PropTypes.bool.isRequired,
}

export default EditGroupTitleModal